import connectedBannerImage from 'img/freemium/onboardingFreemiumBanner.png';
import connectedBannerImageDark from 'img/freemium/onboardingFreemiumBannerDark.png';
import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    freemiumTariffPurchaseID,
    isControlFreemium,
    isHardFreemium,
    isSoftFreemium,
} from 'reactApp/appHelpers/featuresHelpers/features/freemium';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { productsController } from 'reactApp/modules/products/products.controller';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import { renderFreemiumAboutModal } from 'reactApp/ui/FreemiumAboutModal';
import { InformationAlertBanner, InformationBannerType } from 'reactApp/ui/InformationAlertBanner/InformationAlertBanner';

import styles from './FreemiumConnectedBanner.css';
import { sendFreemiumConnectedBannerDwh } from './FreemiumConnectedBanner.helpers';

const getDiscountTariffId = (): string => {
    return freemiumTariffPurchaseID || 'W256GB_1m_family_features_discount_3m';
};

const getAnalyticsName = (): string => {
    if (isHardFreemium) {
        return 'mnz_family_hard_freemium_subscription_information';
    }
    if (isSoftFreemium) {
        return 'mnz_family_soft_freemium_subscription_information';
    }
    if (isControlFreemium) {
        return 'mnz_family_trial_freemium_subscription_information';
    }
    return 'mnz_family_soft_freemium_subscription_information';
};

const getPaySource = (): string => {
    if (isHardFreemium) {
        return 'mnz_family_unlimited_hard_freemium_banner_subscription_information';
    }
    if (isSoftFreemium) {
        return 'mnz_family_unlimited_soft_freemium_banner_subscription_information';
    }
    if (isControlFreemium) {
        return 'mnz_family_unlimited_trial_banner_subscription_information';
    }
    return 'mnz_family_unlimited_soft_freemium_banner_subscription_information';
};

export const FreemiumConnectedBanner = memo(() => {
    const dispatch = useDispatch();
    const isDarkTheme = useSelector(isCurrentDarkTheme);
    const analyticsName = getAnalyticsName();
    const paySource = getPaySource();

    useEffect(() => {
        sendFreemiumConnectedBannerDwh('show', analyticsName);
    }, [analyticsName]);

    const handleComponentsClick = useCallback(() => {
        sendFreemiumConnectedBannerDwh('click', `${analyticsName}_components`);
        renderFreemiumAboutModal();
    }, [analyticsName]);

    const handleExtendClick = useCallback(() => {
        sendFreemiumConnectedBannerDwh('click', `${analyticsName}_extend`);
        productsController.loadProducts().then(() => {
            dispatch(
                openTariffBuy({
                    title: 'Семейный тариф Mail Space',
                    productId: getDiscountTariffId(),
                    paySource,
                })
            );
        });
    }, [dispatch, analyticsName, paySource]);

    return (
        <div className={styles.wrapper}>
            <img src={isDarkTheme ? connectedBannerImageDark : connectedBannerImage} className={styles.image} />
            <InformationAlertBanner
                title="Вы подключили пробную подписку"
                content="У неё много классных возможностей — самое время познакомиться"
                primaryButtonTitle="Что есть в подписке?"
                secondaryButtonTitle="Продлить со скидкой"
                type={InformationBannerType.info}
                hideIcon={true}
                customPaddingLeft="102px"
                buttonsMaxWidth="550px"
                primaryButtonClassName={styles.primaryButton}
                secondaryButtonClassName={styles.secondaryButton}
                responsiveButtons={true}
                onPrimaryClick={handleComponentsClick}
                onSecondaryClick={handleExtendClick}
                closable={false}
            />
        </div>
    );
});

FreemiumConnectedBanner.displayName = 'FreemiumConnectedBanner';
